import { render, staticRenderFns } from "./SuccessfulyBought.vue?vue&type=template&id=6db2cbaf&scoped=true&"
import script from "./SuccessfulyBought.vue?vue&type=script&lang=ts&"
export * from "./SuccessfulyBought.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessfulyBought.vue?vue&type=style&index=0&id=6db2cbaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2cbaf",
  null
  
)

export default component.exports